import { registry } from "src/app/enum"

export enum ClientExpiryRuleType {
  Percent = 1,
  Value = 2
}

(ClientExpiryRuleType as any).__typeName = 'ClientExpiryRuleType';
registry[(<any>ClientExpiryRuleType).__typeName] = ClientExpiryRuleType;
